import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { NewEventWizard } from '../../modules/events/wizard/new-event-wizard.js';
import { parseNewEventSearch } from '../../modules/events/wizard/parse-new-event-search.js';

export const Route = createFileRoute('/events/new')({
  validateSearch: parseNewEventSearch,
  component: NewEventPage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component
function NewEventPage() {
  const { brandId, customerId } = Route.useSearch();
  return (
    <RouteGuard route="/events/new">
      <NewEventWizard brandId={brandId} customerId={customerId} />
    </RouteGuard>
  );
}
